// src/components/util/confirmAddDialog.js
// Generic "are you sure?" confirmation shown right before a new record is
// actually written, on every "Add ..." form in the app. Kept intentionally
// simple/reusable (like ConfirmPromoteDialog) — the caller owns the pending
// payload and only fires the real API call from onConfirm.
import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AppDialog from "./appDialog";

const ConfirmAddDialog = ({ open, onClose, onConfirm, itemLabel = "record", confirmLabel = "Add" }) => (
  <AppDialog
    open={open}
    onClose={onClose}
    title="Confirm New Entry"
    maxWidth="xs"
    actions={
      <>
        <Button variant="text" color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <Typography variant="body2" color="text.secondary">
      Are you sure you want to add this {itemLabel}?
    </Typography>
  </AppDialog>
);

export default ConfirmAddDialog;
